import { useState } from "react";
import { Box, Paper, Tooltip } from "@mui/material";
import "../../common/Common.css";
import { DataGrid } from "@mui/x-data-grid";
import BorderColorRoundedIcon from "@mui/icons-material/BorderColorRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";

// ---- shared palette (matches PatientTable.js) ---------------------------
const palette = {
  teal: "#4B49AC",
  tealDark: "#37357D",
  tealSoft: "#EEEDF9",
  ink: "#1F2937",
  slate: "#6B7280",
  line: "#E6E9ED",
  bg: "#FAFBFC",
  coral: "#FF6B57",
  coralSoft: "#FFEFEC",
};

const actionIconBtn = (color, hoverBg) => ({
  width: 30,
  height: 30,
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  color,
  transition: "background-color 120ms ease",
  "&:hover": { backgroundColor: hoverBg },
});

export default function BranchTable({ branchDetails, handleBranchtEdit, searchQuery = "" }) {
  const filteredRows = branchDetails?.filter((row) =>
    Object.values(row).some(
      (val) =>
        val && val.toString().toLowerCase().includes(searchQuery.toLowerCase()),
    ),
  );

  const columns = [
    { field: "name", headerName: "Branch", flex: 1, minWidth: 120, editable: false },
    { field: "contact_number", headerName: "Phone", flex: 1, minWidth: 120, editable: false },
    { field: "address", headerName: "Address", flex: 2, minWidth: 150, editable: false },
    { field: "start_time", headerName: "Start Time", flex: 1, minWidth: 100, editable: false },
    { field: "close_time", headerName: "End Time", flex: 1, minWidth: 100, editable: false },
    { field: "break_start_time", headerName: "Break Start", flex: 1, minWidth: 120, editable: false },
    { field: "break_end_time", headerName: "Break End", flex: 1, minWidth: 120, editable: false },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      flex: 0.8,
      minWidth: 100,
      renderCell: (param) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "6px",
            width: "100%",
            height: "100%",
          }}
        >
          <Tooltip title="Edit branch">
            <Box
              sx={actionIconBtn(palette.slate, "#F1F5F9")}
              onClick={() => handleBranchtEdit(param.row.id)}
            >
              <BorderColorRoundedIcon sx={{ fontSize: "17px" }} />
            </Box>
          </Tooltip>
          <Tooltip title="Delete branch">
            <Box
              sx={actionIconBtn(palette.coral, palette.coralSoft)}
              onClick={() => {
                // handleServiceDelete(param.row.id);
              }}
            >
              <DeleteRoundedIcon sx={{ fontSize: "17px" }} />
            </Box>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "14px",
        border: `1px solid ${palette.line}`,
        overflow: "hidden",
      }}
    >
      <Box sx={{ height: 400, width: "100%" }}>
        <DataGrid
          sx={{
            fontFamily: "Nunito, sans-serif",
            border: "none",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: palette.bg,
              borderBottom: `1px solid ${palette.line}`,
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontSize: "12.5px",
              fontWeight: 700,
              color: palette.slate,
              textTransform: "uppercase",
              letterSpacing: "0.03em",
            },
            "& .MuiDataGrid-cell": {
              fontSize: "13px",
              borderBottom: `1px solid ${palette.line}`,
            },
            "& .MuiDataGrid-row:hover": {
              backgroundColor: palette.tealSoft,
            },
            "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
              outline: "none",
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: `1px solid ${palette.line}`,
            },
          }}
          rows={filteredRows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 5 },
            },
          }}
          pageSizeOptions={[5]}
          disableRowSelectionOnClick
        />
      </Box>
    </Paper>
  );
}